module.exports = __webpack_public_path__ + "img/185.29c3e472.png";